import { useCallback } from 'react';

import { useAttributesContextualInfo } from '../useAttributesContextualInfo';

import { getAttributeValue } from './getAttributeValue';

import type { Attribute } from '../types';

export function useGetAttributesWithValues() {
  const contextualInfo = useAttributesContextualInfo();

  return useCallback(
    (attributes: Set<Attribute>): SplitIO.Attributes => {
      return Object.fromEntries(
        [...attributes].map(attribute => [
          attribute,
          getAttributeValue(attribute, contextualInfo),
        ])
      );
    },
    [contextualInfo]
  );
}
